import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Link, useMatch } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

export const ImagesBreadcrumb = ({ labels }: { labels?: ReactNode[] }) => {
  const { t } = useTranslation();

  const match = useMatch({
    from: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/',
  });

  const estateId = match?.params.estateId;

  return (
    <nav className="inline-flex items-center text-base text-gray-500" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2">
        {estateId && (
          <li key="images-link" className="flex items-center gap-2">
            <Link
              to="/estates/$estateId/media/images"
              params={{ estateId }}
              className="hover:text-gray-700"
            >
              {t('images')}
            </Link>
          </li>
        )}

        {labels?.map((label, i) => {
          const isLast = i === labels.length - 1;
          return (
            <li key={`${String(label)}-${i}`} className="flex items-center gap-2">
              <ChevronRight width={16} className="text-gray-400" aria-hidden="true" />
              {isLast ? (
                <span className="font-semibold text-gray-900" aria-current="page">
                  {label}
                </span>
              ) : (
                <span className="hover:text-gray-700">{label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
